
import QRCode from "qrcode";
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { uploadImg, doCharge, rechargeAddress } from '../service/getdata'
export default {
data(){
return{
show:false,
msg:"",
fileList: [],
symbol: "usdt",
share_url: "", //分享链接
img: '',
imgshow: false,
address: "",
chainList: ['TRC20', 'ERC20'],
check: 'TRC20',
money: "",
rechargeInfo: {},
receipt_img: "",
list: [{
title: "USDT",
key: "usdt"
},{
title: "BTC",
key: "btc"
},{
title: "ETH",
key: "eth"
}]
}
},
components:{
XHeader,
Toast
},
created(){
console.log(this.list)
this.SETTOKEN()
this.getData()




},
computed:{
...mapState([ 'token', 'url'])
},
methods:{
...mapMutations(['SETTOKEN', 'SETUSERNAME']),

getData(){
var that = this
this.$Loading()
rechargeAddress({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1' || res.status=='0'){
that.rechargeInfo = res.data
if(that.symbol == 'btc'){
that.address = res.data.btc
}
if(that.symbol == 'eth'){
that.address = res.data.eth
}
if(that.symbol == 'usdt'){
that.address = res.data.trc20
}
that.getQRCode()
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
changeChain(chain){
const that = this
if(chain == 'TRC20'){
that.address = this.rechargeInfo.trc20
}
if(chain == 'ERC20'){
that.address = this.rechargeInfo.erc20

}
if(that.symbol == 'btc'){
that.address = this.rechargeInfo.btc
}
if(that.symbol == 'eth'){
that.address = this.rechargeInfo.eth
}
that.getQRCode()
},
save(){








var that = this
this.$Loading()
doCharge({token: this.token, symbol: this.symbol, uid: window.localStorage.getItem("uid"),type:this.check}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){


}
})
}else if(res.status=='-1'){

that.$router.push('/pages/login')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},
getQRCode() {
let opts = {
errorCorrectionLevel: "H",//容错级别
type: "image/png",//生成的二维码类型
quality: 0.3,//二维码质量
margin: 4,//二维码留白边距
width: 200,//宽
height: 200,//高
text:  this.address,//二维码内容
color: {
dark: "#333333",//前景色
light: "#fff"
}
};
this.QRCodeMsg = this.address; 
let msg = document.getElementById("QRcodeCanvas");    
QRCode.toCanvas(msg, this.QRCodeMsg, opts, function (error) {
console.log(error)
});    // 将canvas转成图片格式，可以长按保存
this.img = msg.toDataURL('image/png');
this.imgshow = true;
},
download(selector) {
const canvas = document.querySelector(selector);
const el = document.createElement('a');
el.href = canvas.toDataURL();
el.download = 'qrcode';
const event = new MouseEvent('click');
el.dispatchEvent(event);
},
share(val) {
if (!val) {
return
}
navigator.clipboard.writeText(val).then(() => {
this.sendMsg(this.$t('复制成功'));
})
},
chooseFile(){
this.$refs.upload.click()
},
fileChange(e){
let _this = this
var file=e.target.files[0];
var formdata=new FormData();
formdata.append('图片的字段名',file);
let reader = new FileReader()
reader.readAsDataURL(file) 
reader.onloadend = function () {

console.log(_this.imgSrc)
_this.$Loading()
uploadImg({file: this.result, token: _this.token}).then(data => {
_this.$Loading.close()
console.log(data.data)
if(data.data.status=='1'){
_this.receipt_img =  data.data.data
}else{
_this.sendMsg(data.data.message)
}
}).catch(err => {
file.status = 'failed'
file.message = _this.$t('上传失败')
})
}


},
sendMsg(content) {
this.msg = content;
this.show = true;
}
},
watch:{
symbol: {
handler(curVal, oldVal) {
if(this.symbol == 'usdt'){
this.chainList = ['TRC20', 'ERC20']
}else if(this.symbol=='btc'){
this.chainList = ['BTC']
this.check = 'BTC'
}else{
this.chainList = ['ETH']
this.check = "ETH"
}
this.changeChain()


},
deep: true
},

}
}



// WEBPACK FOOTER //
// ./src/pages/recharge.vue